<script lang="ts">
  import ProgressBar from '../../ui/ProgressBar/ProgressBar.svelte'
  import ProgressBarBackgroundBar from '../../ui/ProgressBar/compounds/ProgressBarBackgroundBar.svelte'
  import ProgressBarCompletionBar from '../../ui/ProgressBar/compounds/ProgressBarCompletionBar.svelte'
  import ProgressBarHoverBar from '../../ui/ProgressBar/compounds/ProgressBarHoverBar.svelte'
  import ProgressBarCursor from '../../ui/ProgressBar/compounds/ProgressBarCursor.svelte'
  import ProgressBarHoverTime from '../../ui/ProgressBar/compounds/ProgressBarHoverTime.svelte'
  import videoStore from '../../../stores/video.svelte'
  import { LIVESTREAM_SECONDS } from '../../../const/livestream'

  let duration = $derived(
    videoStore.state.liveSyncPosition > videoStore.state.dvrDuration
      ? videoStore.state.dvrDuration
      : videoStore.state.liveSyncPosition,
  )

  let currentTime = $derived(
    videoStore.state.liveSyncPosition > videoStore.state.dvrDuration
      ? Math.max(
          0,
          videoStore.state.dvrDuration -
            (videoStore.state.liveSyncPosition - videoStore.state.currentTime),
        )
      : videoStore.state.currentTime,
  )

  let progressBarBackgroundParts = $derived([
    { start: 0, width: 100, left: 0, end: duration, text: '' },
  ])

  let progressBarProgressionParts = $derived([
    {
      width: videoStore.isLive() ? 100 : (currentTime / duration) * 100,
      left: 0,
    },
  ])

  function seekTimeTransformer(time: number) {
    let transformedTime = time
    if (videoStore.state.liveSyncPosition > videoStore.state.dvrDuration) {
      transformedTime +=
        videoStore.state.liveSyncPosition - videoStore.state.dvrDuration
    }
    if (
      videoStore.state.liveSyncPosition - transformedTime <
      LIVESTREAM_SECONDS.ASSIMILATED_LIVE
    ) {
      transformedTime = videoStore.state.liveSyncPosition
    } else if (
      videoStore.state.duration > LIVESTREAM_SECONDS.SECURED_DVR &&
      time < LIVESTREAM_SECONDS.SECURED_DVR
    ) {
      if (videoStore.state.liveSyncPosition > videoStore.state.dvrDuration) {
        transformedTime = LIVESTREAM_SECONDS.SECURED_DVR
      } else {
        transformedTime =
          videoStore.state.liveSyncPosition -
          videoStore.state.dvrDuration +
          LIVESTREAM_SECONDS.SECURED_DVR
      }
    }
    return transformedTime
  }
</script>

<ProgressBar isLiveStream={true} {duration} {seekTimeTransformer}>
  <ProgressBarBackgroundBar backgroundParts={progressBarBackgroundParts} />
  <ProgressBarHoverBar {duration} {currentTime} isLive={videoStore.isLive()} />
  <ProgressBarCompletionBar progressionParts={progressBarProgressionParts} />
  {#if !videoStore.state.isMobileLayout}
    <ProgressBarCursor {duration} {currentTime} isLive={videoStore.isLive()} />
  {/if}
  {#if (videoStore.showControls() || !videoStore.state.isPlaying) && videoStore.state.hasPlaybackStarted}
    <ProgressBarHoverTime {duration} />
  {/if}
</ProgressBar>
